import { render, staticRenderFns } from "./ChooseRedrawPurchaseItemV2.vue?vue&type=template&id=5c662dc7&scoped=true"
import script from "./ChooseRedrawPurchaseItemV2.vue?vue&type=script&lang=js"
export * from "./ChooseRedrawPurchaseItemV2.vue?vue&type=script&lang=js"
import style0 from "./ChooseRedrawPurchaseItemV2.vue?vue&type=style&index=0&id=5c662dc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c662dc7",
  null
  
)

export default component.exports